import React, { useReducer } from 'react'

import { confirmActionInitialState } from './store/State'

import confirmActionReducer from './store/Reducer'

import ConfirmActionService from './Service'

const confirmActionContext = {
  state: confirmActionInitialState,
  handlers: {
    toggleDialog: () => {}
  }
}

export type ConfirmActionContext = typeof confirmActionContext

export const ConfirmActionContextProvider = React.createContext<ConfirmActionContext>(confirmActionContext)

const Provider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(confirmActionReducer, confirmActionInitialState)

  const handlers = {
    toggleDialog: ConfirmActionService.toggleDialog(state, dispatch)
  }

  const contextValue = {
    ...confirmActionContext,
    state,
    handlers
  }

  return <ConfirmActionContextProvider.Provider value={contextValue}>{children}</ConfirmActionContextProvider.Provider>
}

export default Provider
